/**
 * This code was generated by Builder.io.
 */
import React from "react";

const ServiceIntro = () => {
  return (
    <section className="service-intro">
      <h1 className="service-title">Services</h1>
      <p className="service-description">
        At Orbit Financial Services, we provide comprehensive financial planning
        services designed to help you navigate life's financial challenges. Our
        team of experienced advisors works closely with you to create
        personalized strategies that align with your goals
      </p>
    </section>
  );
};

export default ServiceIntro;
